export default "__VITE_ASSET__63890a9c__"